module.exports = __webpack_public_path__ + "img/icon_share.9abdc429.svg";